module.exports = __webpack_public_path__ + "static/partnerMultiDevices-9a57f86834dbdaafbc8356e5746d7d47.png";